import { render } from "./MemberCard.vue?vue&type=template&id=24afa0eb"
import script from "./MemberCard.vue?vue&type=script&lang=js"
export * from "./MemberCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__